<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Bank No.
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="headers"
          :items="bankList"
          v-bind:search="search"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.label }}</td>
              <td align="center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignBankNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  props: {
    branch: {
      type: String,
      default: ''
    },
    fund: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      labels: {
        bank: 'Bank No.'
      },
      filters: {
        bank: undefined
      },
      headers: [{ text: 'Bank No.', align: 'left', value: 'label' }, TableConst.tableActionHeader],
      bankList: [],
      loading: false
    }
  },
  mounted() {
    this.doFetch()
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.bankList = []
      try {
        const apiUrl = this.$store.state.commons.menu.activeBankList
        if (apiUrl) {
          const expand = {
            branch: this.branch,
            fund: this.fund
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result && result.data && result.data.data) {
            this.bankList = result.data.data
          }
        }
      } catch (e) {}
      this.loading = false
    },
    closeDialog() {
      this.filters.bank = ''
      this.$emit('close')
    },
    assignBankNo(data) {
      this.$emit('assign-bank', data)
      this.$emit('assign-bankNo', data.label)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
